import Struct, { placeholder } from "@yume-chan/struct";
import { ScrcpyControlMessageType } from "./type.js";
export var AndroidKeyEventAction;
(function (AndroidKeyEventAction) {
    AndroidKeyEventAction[AndroidKeyEventAction["Down"] = 0] = "Down";
    AndroidKeyEventAction[AndroidKeyEventAction["Up"] = 1] = "Up";
})(AndroidKeyEventAction = AndroidKeyEventAction || (AndroidKeyEventAction = {}));
export var AndroidKeyEventMeta;
(function (AndroidKeyEventMeta) {
    AndroidKeyEventMeta[AndroidKeyEventMeta["AltOn"] = 2] = "AltOn";
    AndroidKeyEventMeta[AndroidKeyEventMeta["CtrlOn"] = 4096] = "CtrlOn";
    AndroidKeyEventMeta[AndroidKeyEventMeta["ShiftOn"] = 1] = "ShiftOn";
    AndroidKeyEventMeta[AndroidKeyEventMeta["MetaOn"] = 65536] = "MetaOn";
})(AndroidKeyEventMeta = AndroidKeyEventMeta || (AndroidKeyEventMeta = {}));
// https://cs.android.com/android/platform/superproject/+/master:frameworks/base/core/java/android/view/KeyEvent.java;l=97;drc=95c1165bb895dd844e1793460710f7163dd330a3
// Most name follows Web API `KeyboardEvent.code`,
// Android-only (not exist in HID keyboard standard) keys are prefixed by `Android`.
export var AndroidKeyCode;
(function (AndroidKeyCode) {
    AndroidKeyCode[AndroidKeyCode["AndroidHome"] = 3] = "AndroidHome";
    AndroidKeyCode[AndroidKeyCode["AndroidBack"] = 4] = "AndroidBack";
    AndroidKeyCode[AndroidKeyCode["AndroidCall"] = 5] = "AndroidCall";
    AndroidKeyCode[AndroidKeyCode["AndroidEndCall"] = 6] = "AndroidEndCall";
    AndroidKeyCode[AndroidKeyCode["Digit0"] = 7] = "Digit0";
    AndroidKeyCode[AndroidKeyCode["Digit1"] = 8] = "Digit1";
    AndroidKeyCode[AndroidKeyCode["Digit2"] = 9] = "Digit2";
    AndroidKeyCode[AndroidKeyCode["Digit3"] = 10] = "Digit3";
    AndroidKeyCode[AndroidKeyCode["Digit4"] = 11] = "Digit4";
    AndroidKeyCode[AndroidKeyCode["Digit5"] = 12] = "Digit5";
    AndroidKeyCode[AndroidKeyCode["Digit6"] = 13] = "Digit6";
    AndroidKeyCode[AndroidKeyCode["Digit7"] = 14] = "Digit7";
    AndroidKeyCode[AndroidKeyCode["Digit8"] = 15] = "Digit8";
    AndroidKeyCode[AndroidKeyCode["Digit9"] = 16] = "Digit9";
    /**
     * '*' key.
     */
    AndroidKeyCode[AndroidKeyCode["Star"] = 17] = "Star";
    /**
     * '#' key.
     */
    AndroidKeyCode[AndroidKeyCode["Pound"] = 18] = "Pound";
    /**
     * Directional Pad Up key.
     */
    AndroidKeyCode[AndroidKeyCode["ArrowUp"] = 19] = "ArrowUp";
    /**
     * Directional Pad Down key.
     */
    AndroidKeyCode[AndroidKeyCode["ArrowDown"] = 20] = "ArrowDown";
    /**
     * Directional Pad Left key.
     */
    AndroidKeyCode[AndroidKeyCode["ArrowLeft"] = 21] = "ArrowLeft";
    /**
     * Directional Pad Right key.
     */
    AndroidKeyCode[AndroidKeyCode["ArrowRight"] = 22] = "ArrowRight";
    /**
     * Directional Pad Center key.
     */
    AndroidKeyCode[AndroidKeyCode["AndroidDPadCenter"] = 23] = "AndroidDPadCenter";
    AndroidKeyCode[AndroidKeyCode["VolumeUp"] = 24] = "VolumeUp";
    AndroidKeyCode[AndroidKeyCode["VolumeDown"] = 25] = "VolumeDown";
    AndroidKeyCode[AndroidKeyCode["Power"] = 26] = "Power";
    AndroidKeyCode[AndroidKeyCode["AndroidCamera"] = 27] = "AndroidCamera";
    AndroidKeyCode[AndroidKeyCode["Clear"] = 28] = "Clear";
    AndroidKeyCode[AndroidKeyCode["KeyA"] = 29] = "KeyA";
    AndroidKeyCode[AndroidKeyCode["KeyB"] = 30] = "KeyB";
    AndroidKeyCode[AndroidKeyCode["KeyC"] = 31] = "KeyC";
    AndroidKeyCode[AndroidKeyCode["KeyD"] = 32] = "KeyD";
    AndroidKeyCode[AndroidKeyCode["KeyE"] = 33] = "KeyE";
    AndroidKeyCode[AndroidKeyCode["KeyF"] = 34] = "KeyF";
    AndroidKeyCode[AndroidKeyCode["KeyG"] = 35] = "KeyG";
    AndroidKeyCode[AndroidKeyCode["KeyH"] = 36] = "KeyH";
    AndroidKeyCode[AndroidKeyCode["KeyI"] = 37] = "KeyI";
    AndroidKeyCode[AndroidKeyCode["KeyJ"] = 38] = "KeyJ";
    AndroidKeyCode[AndroidKeyCode["KeyK"] = 39] = "KeyK";
    AndroidKeyCode[AndroidKeyCode["KeyL"] = 40] = "KeyL";
    AndroidKeyCode[AndroidKeyCode["KeyM"] = 41] = "KeyM";
    AndroidKeyCode[AndroidKeyCode["KeyN"] = 42] = "KeyN";
    AndroidKeyCode[AndroidKeyCode["KeyO"] = 43] = "KeyO";
    AndroidKeyCode[AndroidKeyCode["KeyP"] = 44] = "KeyP";
    AndroidKeyCode[AndroidKeyCode["KeyQ"] = 45] = "KeyQ";
    AndroidKeyCode[AndroidKeyCode["KeyR"] = 46] = "KeyR";
    AndroidKeyCode[AndroidKeyCode["KeyS"] = 47] = "KeyS";
    AndroidKeyCode[AndroidKeyCode["KeyT"] = 48] = "KeyT";
    AndroidKeyCode[AndroidKeyCode["KeyU"] = 49] = "KeyU";
    AndroidKeyCode[AndroidKeyCode["KeyV"] = 50] = "KeyV";
    AndroidKeyCode[AndroidKeyCode["KeyW"] = 51] = "KeyW";
    AndroidKeyCode[AndroidKeyCode["KeyX"] = 52] = "KeyX";
    AndroidKeyCode[AndroidKeyCode["KeyY"] = 53] = "KeyY";
    AndroidKeyCode[AndroidKeyCode["KeyZ"] = 54] = "KeyZ";
    AndroidKeyCode[AndroidKeyCode["Comma"] = 55] = "Comma";
    AndroidKeyCode[AndroidKeyCode["Period"] = 56] = "Period";
    AndroidKeyCode[AndroidKeyCode["AltLeft"] = 57] = "AltLeft";
    AndroidKeyCode[AndroidKeyCode["AltRight"] = 58] = "AltRight";
    AndroidKeyCode[AndroidKeyCode["ShiftLeft"] = 59] = "ShiftLeft";
    AndroidKeyCode[AndroidKeyCode["ShiftRight"] = 60] = "ShiftRight";
    AndroidKeyCode[AndroidKeyCode["Tab"] = 61] = "Tab";
    AndroidKeyCode[AndroidKeyCode["Space"] = 62] = "Space";
    AndroidKeyCode[AndroidKeyCode["AndroidSymbol"] = 63] = "AndroidSymbol";
    AndroidKeyCode[AndroidKeyCode["AndroidExplorer"] = 64] = "AndroidExplorer";
    AndroidKeyCode[AndroidKeyCode["AndroidEnvelope"] = 65] = "AndroidEnvelope";
    AndroidKeyCode[AndroidKeyCode["Enter"] = 66] = "Enter";
    AndroidKeyCode[AndroidKeyCode["Backspace"] = 67] = "Backspace";
    AndroidKeyCode[AndroidKeyCode["Backquote"] = 68] = "Backquote";
    AndroidKeyCode[AndroidKeyCode["Minus"] = 69] = "Minus";
    AndroidKeyCode[AndroidKeyCode["Equal"] = 70] = "Equal";
    AndroidKeyCode[AndroidKeyCode["BracketLeft"] = 71] = "BracketLeft";
    AndroidKeyCode[AndroidKeyCode["BracketRight"] = 72] = "BracketRight";
    AndroidKeyCode[AndroidKeyCode["Backslash"] = 73] = "Backslash";
    AndroidKeyCode[AndroidKeyCode["Semicolon"] = 74] = "Semicolon";
    AndroidKeyCode[AndroidKeyCode["Quote"] = 75] = "Quote";
    AndroidKeyCode[AndroidKeyCode["Slash"] = 76] = "Slash";
    AndroidKeyCode[AndroidKeyCode["At"] = 77] = "At";
    AndroidKeyCode[AndroidKeyCode["AndroidNum"] = 78] = "AndroidNum";
    AndroidKeyCode[AndroidKeyCode["AndroidHeadsetHook"] = 79] = "AndroidHeadsetHook";
    /**
     * Camera Focus key。
     */
    AndroidKeyCode[AndroidKeyCode["AndroidFocus"] = 80] = "AndroidFocus";
    AndroidKeyCode[AndroidKeyCode["Plus"] = 81] = "Plus";
    AndroidKeyCode[AndroidKeyCode["Menu"] = 82] = "Menu";
    AndroidKeyCode[AndroidKeyCode["AndroidNotification"] = 83] = "AndroidNotification";
    AndroidKeyCode[AndroidKeyCode["AndroidSearch"] = 84] = "AndroidSearch";
    AndroidKeyCode[AndroidKeyCode["PageUp"] = 92] = "PageUp";
    AndroidKeyCode[AndroidKeyCode["PageDown"] = 93] = "PageDown";
    AndroidKeyCode[AndroidKeyCode["Escape"] = 111] = "Escape";
    AndroidKeyCode[AndroidKeyCode["Delete"] = 112] = "Delete";
    AndroidKeyCode[AndroidKeyCode["ControlLeft"] = 113] = "ControlLeft";
    AndroidKeyCode[AndroidKeyCode["ControlRight"] = 114] = "ControlRight";
    AndroidKeyCode[AndroidKeyCode["CapsLock"] = 115] = "CapsLock";
    AndroidKeyCode[AndroidKeyCode["ScrollLock"] = 116] = "ScrollLock";
    AndroidKeyCode[AndroidKeyCode["MetaLeft"] = 117] = "MetaLeft";
    AndroidKeyCode[AndroidKeyCode["MetaRight"] = 118] = "MetaRight";
    AndroidKeyCode[AndroidKeyCode["AndroidFunction"] = 119] = "AndroidFunction";
    AndroidKeyCode[AndroidKeyCode["PrintScreen"] = 120] = "PrintScreen";
    AndroidKeyCode[AndroidKeyCode["Pause"] = 121] = "Pause";
    AndroidKeyCode[AndroidKeyCode["Home"] = 122] = "Home";
    AndroidKeyCode[AndroidKeyCode["End"] = 123] = "End";
    AndroidKeyCode[AndroidKeyCode["Insert"] = 124] = "Insert";
    AndroidKeyCode[AndroidKeyCode["AndroidForward"] = 125] = "AndroidForward";
    AndroidKeyCode[AndroidKeyCode["F1"] = 131] = "F1";
    AndroidKeyCode[AndroidKeyCode["F2"] = 132] = "F2";
    AndroidKeyCode[AndroidKeyCode["F3"] = 133] = "F3";
    AndroidKeyCode[AndroidKeyCode["F4"] = 134] = "F4";
    AndroidKeyCode[AndroidKeyCode["F5"] = 135] = "F5";
    AndroidKeyCode[AndroidKeyCode["F6"] = 136] = "F6";
    AndroidKeyCode[AndroidKeyCode["F7"] = 137] = "F7";
    AndroidKeyCode[AndroidKeyCode["F8"] = 138] = "F8";
    AndroidKeyCode[AndroidKeyCode["F9"] = 139] = "F9";
    AndroidKeyCode[AndroidKeyCode["F10"] = 140] = "F10";
    AndroidKeyCode[AndroidKeyCode["F11"] = 141] = "F11";
    AndroidKeyCode[AndroidKeyCode["F12"] = 142] = "F12";
    AndroidKeyCode[AndroidKeyCode["NumLock"] = 143] = "NumLock";
    AndroidKeyCode[AndroidKeyCode["Numpad0"] = 144] = "Numpad0";
    AndroidKeyCode[AndroidKeyCode["Numpad1"] = 145] = "Numpad1";
    AndroidKeyCode[AndroidKeyCode["Numpad2"] = 146] = "Numpad2";
    AndroidKeyCode[AndroidKeyCode["Numpad3"] = 147] = "Numpad3";
    AndroidKeyCode[AndroidKeyCode["Numpad4"] = 148] = "Numpad4";
    AndroidKeyCode[AndroidKeyCode["Numpad5"] = 149] = "Numpad5";
    AndroidKeyCode[AndroidKeyCode["Numpad6"] = 150] = "Numpad6";
    AndroidKeyCode[AndroidKeyCode["Numpad7"] = 151] = "Numpad7";
    AndroidKeyCode[AndroidKeyCode["Numpad8"] = 152] = "Numpad8";
    AndroidKeyCode[AndroidKeyCode["Numpad9"] = 153] = "Numpad9";
    AndroidKeyCode[AndroidKeyCode["NumpadDivide"] = 154] = "NumpadDivide";
    AndroidKeyCode[AndroidKeyCode["NumpadMultiply"] = 155] = "NumpadMultiply";
    AndroidKeyCode[AndroidKeyCode["NumpadSubtract"] = 156] = "NumpadSubtract";
    AndroidKeyCode[AndroidKeyCode["NumpadAdd"] = 157] = "NumpadAdd";
    AndroidKeyCode[AndroidKeyCode["NumpadDecimal"] = 158] = "NumpadDecimal";
    AndroidKeyCode[AndroidKeyCode["NumpadComma"] = 159] = "NumpadComma";
    AndroidKeyCode[AndroidKeyCode["NumpadEnter"] = 160] = "NumpadEnter";
    AndroidKeyCode[AndroidKeyCode["NumpadEquals"] = 161] = "NumpadEquals";
    AndroidKeyCode[AndroidKeyCode["NumpadLeftParen"] = 162] = "NumpadLeftParen";
    AndroidKeyCode[AndroidKeyCode["NumpadRightParen"] = 163] = "NumpadRightParen";
    AndroidKeyCode[AndroidKeyCode["VolumeMute"] = 164] = "VolumeMute";
    AndroidKeyCode[AndroidKeyCode["AndroidAppSwitch"] = 187] = "AndroidAppSwitch";
    AndroidKeyCode[AndroidKeyCode["AndroidCut"] = 277] = "AndroidCut";
    AndroidKeyCode[AndroidKeyCode["AndroidCopy"] = 278] = "AndroidCopy";
    AndroidKeyCode[AndroidKeyCode["AndroidPaste"] = 279] = "AndroidPaste";
})(AndroidKeyCode = AndroidKeyCode || (AndroidKeyCode = {}));
export const ScrcpyInjectKeyCodeControlMessage = new Struct()
    .uint8("type", ScrcpyControlMessageType.InjectKeyCode)
    .uint8("action", placeholder())
    .uint32("keyCode")
    .uint32("repeat")
    .uint32("metaState");
//# sourceMappingURL=inject-keycode.js.map